import { ProgramService } from 'app/client-core/services/program.service';
import { Component, OnInit, ViewChild, TemplateRef, Input, AfterViewInit, NgZone } from '@angular/core';
import { BsModalRef, BsModalService, TypeaheadMatch } from 'ngx-bootstrap';
import { ValidationMessage } from '../../../validation';
import { DropzoneComponent } from 'ngx-dropzone-wrapper';
import { ApiService } from 'app/client-core/api.service';
import { ProgramId } from 'app/client-core/dtos/programs.model';


@Component({
    selector: 'import-shipping-location-modal',
    templateUrl: './import.modal.component.html',
    styleUrls: [
        './import.modal.component.scss'
    ]
})
export class ImportModalComponent implements OnInit, AfterViewInit {
    @Input() programId?: number;
    @Input() deliveryDate?: string;
    @Input() deliveryNotes?: string;

    @ViewChild(DropzoneComponent) drpzone: DropzoneComponent;
    public validationMessages: ValidationMessage;
    config;
    file: any;
    ready: boolean;

    constructor(
        private apiService: ApiService,
        private zone: NgZone,
        private modalRef: BsModalRef,
        private programService: ProgramService
    ) {
        const self = this;
        this.config = {
        autoProcessQueue: false,
        acceptedFiles: '.csv',
        uploadMultiple: false,
        maxFiles: 1,
        dictDefaultMessage: 'Click or drop files here',
        init: function() {
            this.on('addedfile', function(file) {
            self.zone.run(() => {
                console.log(file);
                self.file = file;
            })
            });
        }
        };
    }

    ngAfterViewInit(): void {

    }

    ngOnInit(): void {
        this.ready = true;
    }

    close(): void {
        this.modalRef.hide();
    }

    processUpload() {
        this.apiService.uploadShippingLocations(this.file, this.programId, this.deliveryDate, this.deliveryNotes).subscribe(data => {
        const response = (data as any)
        try {
            if (!response.body.hasError) {
                this.drpzone.directiveRef.dropzone().removeAllFiles();
                this.validationMessages = new ValidationMessage(null, true, 'Upload Complete', 'success', 10);
                this.programService.addressAdded.next(new ProgramId(this.programId));
                this.close();
            } else {
                // tslint:disable-next-line:max-line-length
                let errorString = 'One or more entries where unable to be imported due to data provided in the following fields <br>';
                errorString += response.body.errorMessage;
                errorString = errorString.replace(/\n/g, '<br>')
                this.validationMessages = new ValidationMessage(null, true, errorString, errorString, 30).isDanger();
            }
        } catch (error) {
        }
        }, error => {
        });
    }

    onUploadSuccess() {

    }

    onUploadError() {

    }
}



// WEBPACK FOOTER //
// ./src/app/+tactic-catalog/finalize/import/import.modal.component.ts